import { useEffect } from "react";
import { installReferralLanding } from "@/lib/referral/referral-landing-dom";

/** 紹介リンクで来た人の紹介コードを、LINE の入口と /women の頁へ運ぶ (lib/referral/referral-landing.ts) */
export function ReferralLandingSync() {
  useEffect(() => {
    let storage: Storage | null = null;
    try {
      storage = window.localStorage;
    } catch {
      storage = null;
    }
    return installReferralLanding(document, storage, window.location.href);
  }, []);
  return null;
}
